import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "HeaderCharms"*/ "./lazyIndex"), { name: "HeaderCharms" });

export const SkypeCharmStub: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.SkypeCharm);
export const MergedNotificationPane: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.MergedNotificationPane);
